import { View } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      alignItems: 'center',
      flexDirection: 'row',
      height: theme.sizingSmall,
      minWidth: theme.sizingSmall,
      maxWidth: theme.sizingTiny * theme.sizingTiny,
      display: 'flex',
      borderRadius: theme.borderRadiusPill,
      paddingLeft: theme.paddingInsetTwopulse,
      paddingRight: theme.paddingInsetTwopulse,
    },
    variants: {
      variant: {
        'on-sale': {
          backgroundColor: theme.colorLabelingFillOnsaleDefault,
          maxWidth: theme.sizingHuge,
        },
        principal: {
          backgroundColor: theme.colorLabelingFillPrincipalDefault,
        },
        secondary: {
          backgroundColor: theme.colorLabelingFillSecondaryDefault,
        },
        'clube-raia': {
          backgroundColor: theme.colorLabelingFillClubeDefault,
        },
        'clube-drogasil': {
          backgroundColor: theme.colorLabelingFillClubeDefault,
        },
        assinatura: {
          backgroundColor: theme.colorLabelingFillAssinaturaDefault,
        },
        generico: {
          backgroundColor: theme.colorLabelingFillGenericoDefault,
        },
        'medicamento-de-geladeira': {
          backgroundColor: theme.colorLabelingFillRefrigerateDefault,
        },
        'receita-obrigatoria': {
          backgroundColor: theme.colorLabelingFillPrescriptionDefault,
        },
        referencia: {
          backgroundColor: theme.colorLabelingFillReferenciaDefault,
        },
        similar: {
          backgroundColor: theme.colorLabelingFillSimilarDefault,
        },
        'ganhe-stix': {
          backgroundColor: theme.colorLabelingFillStixDefault,
        },
        'trocar-stix': {
          backgroundColor: theme.colorLabelingFillStixDefault,
        },
      },
    },
  }
})

export const Content = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'transparent',
    },
    variants: {
      hasIcon: {
        true: {
          gap: theme.spacingInlineHalfpulse,
        },
      },
    },
  }
})
